export const BUSINESS = 'BestPark Oy';
export const SUPPORT_EMAIL = 'info@bestpark.fi';
export const ADDRESS = 'Avainkierto 15';
export const POSTAL = 'FI-05840 Hyvinkää';
export const POSTAL_RAW = '05840 Hyvinkää';
export const SUPPORT_NUMBER_FORMATTED = '+358 300 47 22 99';
export const SUPPORT_NUMBER = '+358300472299';
export const BUSINESS_ID = '3119984-1';
